export default {
  inserted: function (el, { value }) {
    let w = window.innerWidth;
    let w2 = w / 2;

    let currentOffset = el.getBoundingClientRect();
    let offset = value[0].$el.getBoundingClientRect();

    value[0].$el.style.zIndex = 101;
    value[0].$el.style.boxShadow = '0px 0px 8px rgba(0,0,0,0.2)';
    el.style.top = (offset.top + offset.height + 5) + 'px';
    
    if (w2 > (w - offset.left)) {
      el.style.right = '10px';
    } else {
      el.style.left = offset.left + 'px';
    }
  },
  unbind: function (el, { value }) {
    value[0].$el.style.zIndex = 'auto';
    value[0].$el.style.boxShadow = 'none';
  }
};